import { BPagination } from './pagination';
import { pluginFactory } from '../../utils/plugins';
var PaginationPlugin = /*#__PURE__*/pluginFactory({
  components: {
    BPagination: BPagination
  }
});
export { PaginationPlugin, BPagination };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/pagination/index.js
// module id = 262
// module chunks = 0